window.HelpMeChooseQuestionData = [
  {
    id: 'choose-1',
    question: '1.¿Qué tipo de piscina tienes?',
    multiSelect: false,
    options: [
      {
        id: 'q1-A',
        text: 'Piscina enterrada',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose1-A.png',
        width: 404,
        height: 300,
        alt: 'Piscina enterrada',
      },
      {
        id: 'q1-B',
        text: 'Piscina elevada',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose1-B.png',
        width: 404,
        height: 300,
        alt: 'Piscina elevada',
      },
      {
        id: 'q1-C',
        text: 'No estoy seguro/a',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose4-D.png',
        width: 820,
        height: 72,
        alt: 'No estoy seguro/a',
        extraClass: 'not-sure',
      },
    ],
  },
  {
    id: 'choose-2',
    question: '2.¿Qué descripción se ajusta mejor al diseño de tu piscina?(Se permiten varias respuestas)',
    multiSelect: true,
    options: [
      {
        id: 'q2-A',
        text: 'Mayormente regular y rectangular',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-A.png',
        width: 404,
        height: 143,
        alt: 'Pool layout option',
      },
      {
        id: 'q2-B',
        text: 'Forma curva o libre',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-B.png',
        width: 404,
        height: 143,
        alt: 'Pool layout option',
      },
      {
        id: 'q2-C',
        text: 'Con pendientes, zonas profundas o transiciones irregulares',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-C.png',
        width: 404,
        height: 143,
        alt: 'Pool layout option',
      },
      {
        id: 'q2-D',
        text: 'Con escalones, repisas o zona poco profunda tipo solárium',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-D.png',
        width: 404,
        height: 143,
        alt: 'Pool layout option',
      },
      {
        id: 'q2-E',
        text: 'No estoy seguro/a',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose4-D.png',
        width: 820,
        height: 72,
        alt: 'No estoy seguro/a',
        extraClass: 'not-sure',
      },
    ],
  },
  {
    id: 'choose-3',
    question: '3.¿Qué tamaño tiene tu piscina?',
    multiSelect: false,
    options: [
      {
        id: 'q3-A',
        text: 'Piscina pequeña, hasta 6 m × 5 m',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-A.png',
        width: 404,
        height: 186,
        alt: 'Small pool',
      },
      {
        id: 'q3-B',
        text: 'Piscina mediana, hasta 10 m × 5 m',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-B.png',
        width: 404,
        height: 186,
        alt: 'Medium pool',
      },
      {
        id: 'q3-C',
        text: 'Piscina grande, más de 10 m × 5 m',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-C.png',
        width: 404,
        height: 186,
        alt: 'Large pool',
      },
      {
        id: 'q3-D',
        text: "No estoy seguro/a",
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-D.png',
        width: 404,
        height: 186,
        alt: 'Not sure',
      },
    ],
  },
  {
    id: 'choose-4',
    question: '4.¿Cuál es tu mayor reto de limpieza?',
    multiSelect: false,
    options: [
      {
        id: 'q4-A',
        text: 'Residuos ligeros',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_A.png',
        width: 404,
        height: 186,
        alt: 'Complete cleaning coverage',
      },
      {
        id: 'q4-B',
        text: 'Muchas hojas, arena, algas o partículas finas',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_B.png',
        width: 404,
        height: 186,
        alt: 'Easy maintenance',
      },
      {
        id: 'q4-C',
        text: "Zonas difíciles de alcanzar",
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_C.png',
        width: 404,
        height: 186,
        alt: 'Value for money',
      },
      {
        id: 'q4-D',
        text: "No estoy seguro/a",
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_D.png',
        width: 404,
        height: 186,
        alt: 'Not sure',
      },
    ],
  },
  {
    id: 'choose-5',
    question: '5.¿Qué descripción encaja mejor contigo?',
    multiSelect: false,
    options: [
      {
        id: 'q5-A',
        text: 'Pionero tecnológico',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/aov_A.png',
        width: 404,
        height: 186,
        alt: 'Affordable option',
      },
      {
        id: 'q5-B',
        text: 'Buscador de estilo de vida premium',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/aov_C.png',
        width: 404,
        height: 186,
        alt: 'Balanced option',
      },
      {
        id: 'q5-C',
        text: 'Buscador de valor práctico',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/aov_B.png',
        width: 404,
        height: 186,
        alt: 'Strong performance',
      },
      {
        id: 'q5-D',
        text: 'Buscador de comodidad simple',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/5D.png',
        width: 404,
        height: 186,
        alt: 'Top model',
      },
    ],
  },
];
